import { QuestionKeys } from "@busbud/int-schemas/lib/questions";

import type {
  NapiV2Answer,
  NapiV2CartPassenger,
  PassengerPayload
} from "@app/types/napi-v2-passengers-types";
import type {
  PassengerSeatSelectionInstance,
  PassengerSelectedSeat
} from "@app/types/seat-selection-types";

export function applySeatSelectorPassengersOntoCartPassengers(
  passenger: NapiV2CartPassenger,
  seat_selector_passengers: PassengerSeatSelectionInstance[],
  index: number
) {
  const filtered_passenger = Object.fromEntries(
    Object.entries(passenger).filter(([, value]) => value !== null)
  ) as PassengerPayload;

  let modified_passenger: {
    selected_seats: PassengerSelectedSeat[];
    answers?: NapiV2Answer[];
  } = {
    // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    selected_seats: seat_selector_passengers[index].selected_seats
  };

  modified_passenger = assignGenderToPassenger(
    seat_selector_passengers,
    index,
    filtered_passenger,
    modified_passenger
  );

  return {
    ...filtered_passenger,
    ...modified_passenger
  };
}

export function assignGenderToPassenger(
  seat_selector_passengers: PassengerSeatSelectionInstance[],
  index: number,
  filtered_passenger: PassengerPayload,
  modified_passenger: {
    selected_seats: PassengerSelectedSeat[];
    answers?: NapiV2Answer[];
  }
) {
  // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  const gender = seat_selector_passengers[index].questions.gender;
  if (gender) {
    const gender_answer = {
      question_key: QuestionKeys.Selection.Gender,
      value: gender
    };

    if (filtered_passenger.answers) {
      // Create a copy of the answers array
      const updated_answers = [...filtered_passenger.answers];

      // Find existing gender answer index
      const gender_index = updated_answers.findIndex(
        answer => answer.question_key === QuestionKeys.Selection.Gender
      );

      // Replace existing or append new gender answer
      if (gender_index >= 0) {
        updated_answers[gender_index] = gender_answer;
      } else {
        updated_answers.push(gender_answer);
      }

      modified_passenger["answers"] = updated_answers;
    } else {
      modified_passenger["answers"] = [gender_answer];
    }
  }

  return modified_passenger;
}
